<template>
    <div class="col-12 nopads">
        <top-bar :current-view="views.MY_CAMPAIGN_VIEW"/>
        <alert
                :show="alertVisible"
                :message="message"
                :variant="variant"
                @alertShown=alertShown
        />
        <div class="col-12 main-container">
            <div class="col-xl-10 content-container mx-auto">
                <div class="col-12 nopads mt-6">
                    <b-container class="mb-4 pl-0 pr-0">
                      <b-col lg="12" class="no-gutters">
                        <h3>{{ $t("page.my_campaigns") }}</h3>
                      </b-col>
                    </b-container>
                    <keep-alive>
                        <transition name="fade">
                            <campaign-feed
                                    :campaigns="results"
                                    :show-donate="false"/>
                        </transition>
                    </keep-alive>
                </div>
            </div>
            <footer-area />
        </div>
        <div v-if="loading"
             id="loader"
             class="spinner">
        </div>
    </div>
</template>

<script>
    import {alertMixin} from "../mixins/AlertMixin";
    import Alert from "../components/Alert";
    import {views} from "../mixins/ViewMixin";
    import {userHelper} from "../mixins/UserMixin";
    import FairApi from "../modules/api";
    import CampaignFeed from "../components/feed/CampaignFeed";
    import TopBar from "../components/TopBar";
    import FooterArea from "@/components/FooterArea";

    export default {
        name: "my-campaign-view",
        mixins: [alertMixin, views, userHelper],
        components: {FooterArea, TopBar, CampaignFeed, Alert},
        data() {
            return {
                results:[],
                views,
                loading: false
            }
        },
        mounted() {
            this.fetchUserCampaigns()
        },

        methods: {
            fetchUserCampaigns: function () {
                this.loading = true
                FairApi.getWithParams(FairApi.campaign(), {user: this.$store.state.user.id}, this.success, this.failed)
            },

            success: function (response) {
                this.results = response
                this.loading = false
            },

            failed: function () {
                this.loading = false
                this.showAlert(this.$t('common.fetch_failed'))
            },
        }
    }
</script>

<style scoped>

</style>